export default __webpack_public_path__ + "images/LIT.1dc32ea.png";